export const ACTION_TYPE = {
  COPY_ANNOTATION_ID: 'Copy Annotation Id',
  DELETE_ANNOTATION: 'Delete annotation',
  EDIT_ANNOTATION: 'Edit Annotation'
};
export const ACTION_BUTTON_SIZE = {
  COPY_ANNOTATION_ID: 18,
  DELETE_ANNOTATION: 16,
  EDIT_ANNOTATION: 18
};
export const TOAST_MESSAGE = {
  REMOVED_COPIED_ANNOTATION: 'Removed copied annotation',
  SUCCESSFULLY_COPIED_ANNOTATION: 'Successfully copied annotation'
};
export const LABEL_COLOR_PICKER_ID = 'label-color-picker';